import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_2 = { class: "e-badge e-badge-danger e-badge-pill" }
const _hoisted_3 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_4 = { class: "e-badge e-badge-danger e-badge-pill" }

import OrderHead, {OrderStatus, OrderType} from "@/shared/model/orderHead";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";

interface Props {
  orderHead:OrderHead
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryCardHeadComponent',
  props: {
    orderHead: { default: undefined }
  },
  setup(__props: any) {


const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "Datum", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.orderHead?.orderedDate,
                  "value-type": "DateTime"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, "Kunde", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.orderHead?.personName
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "Lieferant", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.orderHead?.supplierName
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, "Bestellt durch", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.orderHead.personName
                }, null, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("td", null, "Bezahlt", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("span", _hoisted_1, "ja", 512), [
                  [_vShow, props.orderHead.paid]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_2, "nein", 512), [
                  [_vShow, !props.orderHead.paid]
                ])
              ])
            ], 512), [
              [_vShow, props.orderHead.orderType===_unref(OrderType).Invoice]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", null, "Abgerechnet", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("span", _hoisted_3, "ja", 512), [
                  [_vShow, props.orderHead.invoiced]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_4, "nein", 512), [
                  [_vShow, !props.orderHead.invoiced]
                ])
              ])
            ], 512), [
              [_vShow, props.orderHead.orderType===_unref(OrderType).Order]
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("td", null, "Status", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogIcon, { icon: "mdi-truck-fast" })
              ])
            ], 512), [
              [_vShow, props.orderHead.statusId!==_unref(OrderStatus).Completed]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})